import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress as MuiCircularProgress } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'

import { busyCursorColorOverride } from '../../themes'

/**
 * Implements Mui CircularProgress.
 *
 * @param {object} props component props
 * @returns {CircularProgress} CircularProgress component
 */
const CircularProgress = props =>
  <ThemeProvider theme={innerTheme =>
    busyCursorColorOverride(innerTheme)}>
    <MuiCircularProgress {...props} />
  </ThemeProvider>

CircularProgress.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   The size of the component. If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit, e.g '3rem'.
   */ 
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   The thickness of the circle.
   */
  thickness: PropTypes.number
}

CircularProgress.defaultProps = {
  size: 40,
  thickness: 3.6
}

export default CircularProgress